import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";
import { externalOtsApi } from "./external-otsApi";
import { ExternalOts, UpdateExternalOts } from "./external-ots.interface";

export const fetchExternalOts = createAsyncThunk<
  APIResponse<ExternalOts[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOts/fetchExternalOts", async (_, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtsApi.endpoints.getExternalOts.initiate()).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener OTS externas",
      details: data.details,
    });
  }
});

export const searchExternalOts = createAsyncThunk<
  APIResponse<ExternalOts[]>,
  string,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOts/searchExternalOts", async (search, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtsApi.endpoints.searchExternalOts.initiate(search)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al buscar OTS externas",
      details: data.details,
    });
  }
});

export const fetchExternalOtsById = createAsyncThunk<
  APIResponse<ExternalOts>,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOts/fetchExternalOtsById", async (id, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtsApi.endpoints.getExternalOtsById.initiate(id)).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al obtener OTS externa",
      details: data.details,
    });
  }
});

export const updateExternalOts = createAsyncThunk<
  APIResponse<ExternalOts>,
  { id: number; changes: UpdateExternalOts },
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>("externalOts/updateExternalOts", async ({ id, changes }, { dispatch, rejectWithValue }) => {
  try {
    const result = await dispatch(externalOtsApi.endpoints.updateExternalOts.initiate({ id, changes })).unwrap();
    return result;
  } catch (error) {
    const apiError = error as APIError;
    const { status, data } = apiError;
    return rejectWithValue({
      status,
      message: data?.message || "Error al actualizar OTS externa",
      details: data.details,
    });
  }
});
